import React from "react";
import Header from "@/components/layout/Header";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";

const BOLT_PORTAL_URL = "https://frog-lake-partner-portal.bolt.host/";

const PortalPage = () => {
  return (
    <div className="font-sans flex flex-col" style={{ height: "100vh", overflow: "hidden" }}>
      <Header />

      {/* Portal toolbar */}
      <div className="bg-white border-b border-gray-200 shadow-sm shrink-0">
        <div className="container mx-auto px-4 h-12 flex items-center justify-between">
          <span className="text-sm font-bold uppercase tracking-wider text-gray-900">
            Partner Portal
          </span>
          <Button
            asChild
            variant="outline"
            size="sm"
            className="text-xs font-bold uppercase tracking-wider"
          >
            <a href={BOLT_PORTAL_URL} target="_blank" rel="noopener noreferrer" data-testid="open-new-tab-btn">
              Open in New Tab <ExternalLink className="ml-2 h-3 w-3" />
            </a>
          </Button>
        </div>
      </div>

      {/* Bolt Portal iframe - fills ALL remaining viewport */}
      <iframe
        src={BOLT_PORTAL_URL}
        title="Frog Lake Partner Portal"
        className="w-full border-none"
        data-testid="portal-iframe"
        allow="clipboard-read; clipboard-write"
        style={{ flex: "1 1 0%", minHeight: 0 }}
      />
    </div>
  );
};

export default PortalPage;
